import {Pipe, PipeTransform} from '@angular/core';

import {IDataTable} from '../components';
import {ITradesSymbolViewData} from '../interfaces';

@Pipe({
    name: 'createTradesTableConfig'
})
export class CreateTradesTableConfigPipe implements PipeTransform {
    transform(
        symbols: { [symbol: string]: ITradesSymbolViewData },
        disableColumnsOptions: boolean = false
    ): IDataTable {
        return Object.keys(symbols).reduce((
            reportTableConfig: IDataTable,
            symbolKey: string,
            symbolIndex: number
        ) => {
            if (symbolIndex === 0) {
                reportTableConfig.columns = symbols[symbolKey].tradesTableConfig.columns;
            }

            reportTableConfig.rows.push(...symbols[symbolKey].tradesTableConfig.rows);

            return reportTableConfig;
        }, {
            rows: [],
            columns: [],
            hiddenColumnIds: [],
            disableColumnsOptions
        });
    }
}
